import { useEffect } from "react";
import React from "react";
import { Box, Grid, ImageList, ImageListItem, Typography } from "@mui/material";
import "./Home.css";
import { useNavigate } from "react-router";
import ShortMovies from "../../assets/ShortMovies.jpg";


const items = [
  {
    src: "/assets/ManStanding.jpg",
    title: "Image Train",
    imageText: "Human Persona",
    router: "/personas",
  },
  {
    src: 'https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/genrated_images/677cfc53731e9e2f60a9113b/6842ac536bd8a1cae0bee85a/btLfsnJafCc3h9py8-G8c_b26357a9746d40dcbc1f238f97bf12ca.jpg',
    title: "AI Persona",
    imageText: "AI Persona",
    router: "/personas",
  },
  {
    src: "https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/genrated_images/677cfc53731e9e2f60a9113b/68146db837ac9f090a4ca50a/TX39_HDELE3vNYjwSYFuD_7312d0d8b88d4422aadb8d11cc3ee07e.png",
    title: "Cartoon",
    imageText: "Cartoon",
    router: "/idea-board/cartoon",
  },
  {
    src: "https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/generated_videos/677cfc53731e9e2f60a9113b/6812186837ac9f090a4ca4fd/76579b3d-95fd-43ed-a2c6-cd41d898347c.mp4",
    title: "Photo_Talks",
    type: "video",
    imageText: "Photo Talks",
    router: "/studio/photo-talks",
  },
  {
    src: '/assets/ProductScape.jpg',
    title: "Productscape",
    imageText: "Productscape",
    router: "/idea-board/productscape",
  },
    {
    src: "https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/generated_videos/677cfc53731e9e2f60a9113b/6812186837ac9f090a4ca4fd/24466855-a281-4899-96f8-932759753450.mp4",
    title: "Podcast",
    type: "video",
    imageText: "Podcast",
    router: "/studio/podcast",
  },
   {
    src: 'https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/677cfc53731e9e2f60a9113b/685e428e94e0f8921c36a887/294040-ramp.jpg',
    title: "Ramp Walk",
    imageText: "Ramp Walk",
    router: "/studio/rampwalk",

  },
   {
    src: "https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/generated_videos/677cfc53731e9e2f60a9113b/fal-ai/minimax/H8dlgJRbi8nTAFGQxg6Lv_output.mp4",
    title: "Cinemotion",
    type: "video",
    imageText: "Cinemotion",
    router: "/studio/cinemotion",
  },
  //    {
  //   src: 'https://devshowcasaai.blob.core.windows.net/677cfc53731e9e2f60a9113b/generated_videos/677cfc53731e9e2f60a9113b/68590b5ec4e2a96de6be37dc/U_73xQH5vldER8q5VC7FW_output.mp4',
  //   title: "Reels",
  //   imageText: "Reels",
  //   router: "/studio/reels",
  //   type: "video",
  // },
   {
    src: ShortMovies,
    title: "Short Films",
    imageText: "Short Films",
    subText: "Coming Soon",
    router: "/comingsoon",
  },
];

// Responsive columns for Masonry grid
const getCols = () => {
  const width = window.innerWidth;
  if (width >= 1440) return 4;
  if (width >= 1100) return 4;
  if (width >= 900) return 4;
  if (width >= 600) return 2;
  if (width >= 559) return 1;
  return 1;
};

const MasonryGrid = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const userEncoded = params.get("user");
    const authEncoded = params.get("auth");
    if (userEncoded && authEncoded) {
      try {
        const userStr = atob(decodeURIComponent(userEncoded));
        const authStr = atob(decodeURIComponent(authEncoded));
        const user = JSON.parse(userStr);
        const auth = JSON.parse(authStr);

        console.log("dfasdfasdfs", user, "auth", auth);
        if(user){
          localStorage.setItem("userId", (user._id || user.id));
          localStorage.setItem("name", (user.name));
          localStorage.setItem("email", (user.email));
          localStorage.setItem("isGoogleLogin", (user.isGoogleLogin));
        }
        if (auth.token) localStorage.setItem("accessToken", (auth.token));
        if (auth.refreshToken) localStorage.setItem("refreshToken", (auth.refreshToken));
        if(auth){
          localStorage.setItem("isVerified", (auth?.user?.verified));
        }
      } catch (e) {
        // Ignore errors
        console.error("Failed to parse user/auth params", e);
      }
    }
  }, []);
  const router = useNavigate();
  const [cols, setCols] = React.useState(getCols());

  React.useEffect(() => {
    const handleResize = () => setCols(getCols());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box className="masonryGridContainer">
      <Grid className="mainMansonryGrid" item spacing={2}>
        <Box className="studioNavBox">
          <Typography variant="h1" gutterBottom className="studioNavHeading">
            Explore Showcasaai
          </Typography>
        </Box>
        <Box className="scroll-container">
          <ImageList
            variant="masonry"
            cols={cols}
            className="masonryGrid"
            sx={{ m: 0 }}
          >
           {items.map((item, index) => {
  if (index === 1 && item.title === "Cartoon") return null;
  return (
    <ImageListItem
      key={index}
      onClick={() => {
        router(item.router || "");
      }}
      className="masonryMain"
    >
      {item.type === "video" ? (
        <Box className="overlay-container">
          <Box className="overlay" />
          <video src={item.src} autoPlay loop muted className="videoHome"  />
        </Box>
      ) : item.title === "Productscape" ? (
        <Box className="overlay-container">
          <img
            src={item.src}
            alt={item.title}
            style={{
              width: "100%",
              height: "400px",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
      ) : item.title === "Reels" ? (
        <Box className="overlay-container">
          <img
            src={item.src}
            alt={item.title}
            style={{
              width: "100%",
              height: "453px",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
      ) : (
        <Box className="overlay-container">
          <Box className="overlay" />
          <img
            src={item.src}
            alt={item.title}
            style={{
              width: "100%",
              display: "block",
            }}
          />
        </Box>
      )}
      <Box className="overlay">
        <Typography variant="subtitle2" className="overlay-title">
          {item.imageText}
        </Typography>
        {item.subText && (
          <Typography variant="subtitle2" className="overlay-subtext">
            {item.subText}
          </Typography>
        )}
      </Box>
    </ImageListItem>
  );
})}
          </ImageList>
        </Box>
      </Grid>
      <Box className="footermansory">
        <Typography variant="body1" className="footerText">
          <span>Exciting new features are on the way!&nbsp;</span> Stay tuned for updates that will enhance your creative experience.
        </Typography>
      </Box>
    </Box>
  );
};

export default MasonryGrid;
